import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'antd';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
import changeLanguage from 'i18n/changeLanguage';
import styles from './LanguageSelector.module.scss';

// Autonyms: a language is always listed in its own language, so these are
// deliberately NOT translated and do not belong in the catalog.
const LANGUAGES = [
  { code: 'es', name: 'Español' },
  { code: 'en', name: 'English' },
];

interface LanguageSelectorProps {
  className?: string;
}

const LanguageMenu: FC = () => {
  const { i18n } = useTranslation();

  return (
    <ul className={styles.Menu}>
      {LANGUAGES.map(({ code, name }) => (
        <li key={code}>
          <button
            type="button"
            className={
              code === i18n.language
                ? `${styles.Option} ${styles.OptionActive}`
                : styles.Option
            }
            onClick={() => {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              changeLanguage(code);
            }}
          >
            {name}
          </button>
        </li>
      ))}
    </ul>
  );
};

const LanguageSelector: FC<LanguageSelectorProps> = ({ className }) => {
  const { i18n } = useTranslation();

  return (
    <Dropdown overlay={<LanguageMenu />} trigger={['click']} className={className}>
      <button type="button" className={styles.Trigger}>
        <GlobalOutlined className={styles.Globe} />
        <span className={styles.Code}>{i18n.language.toUpperCase()}</span>
        <DownOutlined className={styles.Caret} />
      </button>
    </Dropdown>
  );
};

LanguageSelector.defaultProps = {
  className: undefined,
};

export default LanguageSelector;
